module.exports = __webpack_public_path__ + "img/Load_resistor.56372bfd.svg";